import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';

function addClass(ele, name) {
  const classes = ele.className.split(' ')
  classes.push(name)
  ele.className = classes.join(' ')
}

function removeClass(ele, name) {
  const classes = ele.className.split(' ')
  const index = classes.indexOf(name)

  if (index > -1) {
    classes.splice(index, 1)
    ele.className = classes.join(' ')
  }
}

function useFooter() {
  useEffect(() => {
    const mounted = 'mounted'
    const store = document.getElementById('J_store')
    addClass(store, mounted)

    // 有Footer的根目录添加指定class
    const webwapper = 'webwapper'
    const root = document.getElementById('J_root')
    addClass(root, webwapper)

    return () => {
      removeClass(store, mounted)
      removeClass(root, webwapper)
    }
  }, [])
}


export default useFooter